import styled from "styled-components";

const Card = styled.div`

background:#20263A;
padding:22px;
border-radius:22px;

color:#F8FAFC;

`;


export default function TemaPriorityCard({

temas

}){

return(

<Card>

<h2
style={{
    margin:0,
    color:"#F8FAFC"
}}
>
🎯 Temas prioritarios
</h2>

{

temas.map((tema,index)=>(

<div
key={tema.id}
style={{
marginTop:20
}}
>

<h3
style={{
    color:"#F8FAFC",
    marginBottom:8
}}
>
{index+1}. {tema.nombre}
</h3>

<p
style={{
    color:"#94A3B8",
    margin:"6px 0"
}}
>

Impacto estimado

<b
style={{
    color:"#F59E0B"
}}
>

 +{tema.impacto} puntos

</b>

</p>
<p
style={{
    color:"#CBD5E1",
    lineHeight:1.6
}}
>

{tema.explicacion}

</p>

</div>

))

}

</Card>

);

}